import React from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import usePermission from '../hooks/usePermission';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  permissionCode?:number;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  permissionCode,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();
  const hasPermission = usePermission(permissionCode!!);

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        return (isPrivate === !!user) && (permissionCode ? hasPermission : true) ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? '/' : '/dashboard',
              state: { from: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;
